/**
 *  @class
 *  @function AssemblyVideoShowcase
 *  @description Product page assembly videos: switches the video when a
 *  title is clicked/tapped and loads YouTube players only on demand.
 */
if (!customElements.get('assembly-video-showcase')) {
  class AssemblyVideoShowcase extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.assembly-video-showcase__item'));
      this.mediaPanels = Array.from(this.querySelectorAll('.assembly-video-showcase__media'));

      this.items.forEach((item, index) => {
        const trigger = item.querySelector('.assembly-video-showcase__trigger');
        trigger.addEventListener('click', () => this.activateItem(index));
      });

      this.querySelectorAll('.assembly-video-showcase__youtube-poster').forEach((poster) => {
        poster.addEventListener('click', () => this.loadYoutubePlayer(poster), { once: true });
      });
    }

    /**
     * Shows the video of the given list entry and pauses all others.
     * @param {number} index Position of the clicked entry
     */
    activateItem(index) {
      this.items.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        item.classList.toggle('assembly-video-showcase__item--active', isActive);
        item.querySelector('.assembly-video-showcase__trigger').setAttribute('aria-pressed', String(isActive));
      });

      this.mediaPanels.forEach((panel, panelIndex) => {
        if (panelIndex === index) {
          panel.hidden = false;
          return;
        }
        this.pauseMedia(panel);
        panel.hidden = true;
      });
    }

    /**
     * Pauses a hosted video or a loaded YouTube player inside a panel.
     * @param {HTMLElement} panel Media panel to pause
     */
    pauseMedia(panel) {
      const video = panel.querySelector('video');
      if (video && !video.paused) video.pause();

      const youtubeFrame = panel.querySelector('iframe');
      if (youtubeFrame) {
        youtubeFrame.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
          '*'
        );
      }
    }

    /**
     * Replaces the YouTube poster with the player (loaded on click only).
     * @param {HTMLButtonElement} poster Poster button holding the video id
     */
    loadYoutubePlayer(poster) {
      const youtubeFrame = document.createElement('iframe');
      youtubeFrame.className = 'assembly-video-showcase__youtube-frame';
      youtubeFrame.src = `https://www.youtube-nocookie.com/embed/${poster.dataset.youtubeId}?autoplay=1&rel=0&playsinline=1&enablejsapi=1`;
      // Iframe title is the plain video title; "– Video abspielen" belongs only
      // to the poster button's aria-label
      youtubeFrame.title = poster.dataset.videoTitle;
      youtubeFrame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      youtubeFrame.allowFullscreen = true;
      poster.replaceWith(youtubeFrame);
    }
  }
  customElements.define('assembly-video-showcase', AssemblyVideoShowcase);
}
